import {
  ApiABExperimentBucketForId,
  ApiABExperimentId,
} from 'api/abExperiment/types/ApiABExperiment';
import { useUserEnvironment } from 'modules/main/store/hooks/useUserEnvironment';

export function useUserEnvironmentABExperimentBucket<
  TExperimentId extends ApiABExperimentId,
>(
  id: TExperimentId,
): {
  loaded: boolean;
  bucket: ApiABExperimentBucketForId<TExperimentId> | undefined;
} {
  const { environment, isEnvironmentLoaded } = useUserEnvironment();

  if (!isEnvironmentLoaded) {
    return { loaded: false, bucket: undefined };
  }

  const experiment = environment?.abExperiments.find((e) => e.id === id);
  const bucket = experiment?.bucket;
  return { loaded: true, bucket };
}
